import {
  Semanticpmpmvt7fldq2 as Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../models/Theme.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_atStart2tusd7ehy6hjj as get_atStart } from '../helpers.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import {
  TextViewe6rp77b08kos as TextView,
  TextView$_get_content_$ref_4pzcwl16uunx6j4t5r9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb3nnz1ag2pn6vb as TextView$_set_content_$ref_pketfb,
} from '../direct/TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../direct/LinearLayouts.commonHtml.mjs';
import { LinearLayoutElement3ltvobok1lxtu as LinearLayoutElement } from '../direct/LinearLayouts.mjs';
import { timesx4ey3un7ihw1 as times } from '../../models/data.mjs';
import { InteractiveElementbmyfh3g220bh as InteractiveElement } from '../InteractiveElement.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ElementWithChildren23tv2h1ul7ktb as ElementWithChildren } from '../Element.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LabelSemanticClass;
function LabelSemantic() {
  if (LabelSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        LabelSemantic_instance = null;
        super('label');
        LabelSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.get_6y9l0r_k$(SubtextSemantic_getInstance());
      }
      toString() {
        return 'LabelSemantic';
      }
      hashCode() {
        return 88950459;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LabelSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LabelSemantic');
    LabelSemanticClass = $;
  }
  return LabelSemanticClass;
}
var LabelSemantic_instance;
function LabelSemantic_getInstance() {
  if (LabelSemantic_instance === VOID)
    new (LabelSemantic())();
  return LabelSemantic_instance;
}
function LabeledView$_get_content_$ref_5yojet() {
  return constructCallableReference((p0) => p0.get_content_h02jrk_k$(), 1, 0, 128);
}
function LabeledView$_set_content_$ref_ys1c8f() {
  return constructCallableReference((p0, p1) => {
    p0.set_content_lzqutq_k$(p1);
    return Unit_instance;
  }, 2, 0, 129);
}
var LabeledViewClass;
function LabeledView() {
  if (LabeledViewClass === VOID) {
    class $ {
      constructor(container) {
        return new.target.new_com_lightningkite_kiteui_views_l2_LabeledView_6yq45n_k$(container);
      }
      static new_com_lightningkite_kiteui_views_l2_LabeledView_6yq45n_k$(container) {
        var $this = createThis(this);
        $this.container_1 = container;
        var tmp = $this;
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_0 = themed(get_atStart($this), LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (TextView())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        tmp.label_1 = element;
        var tmp_0 = $this;
        var tmp0 = $this.label_1;
        var tmp_1 = KMutableProperty0();
        var tmp_2 = TextView$_get_content_$ref_4pzcwl(tmp0);
        tmp_0.content$delegate_1 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(tmp0));
        $this.set_themeChoice_py59um_k$($this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        $this.container_1.set_vertical_nuap32_k$(true);
        return $this;
      }
      static new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(context) {
        return this.new_com_lightningkite_kiteui_views_l2_LabeledView_6yq45n_k$(new (RowOrCol())(context));
      }
      set_content_lzqutq_k$(_set____db54di) {
        var tmp0 = this.content$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = LabeledView$_get_content_$ref_5yojet();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('content', 1, tmp, tmp_0, LabeledView$_set_content_$ref_ys1c8f());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      get_content_h02jrk_k$() {
        var tmp0 = this.content$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = LabeledView$_get_content_$ref_5yojet();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('content', 1, tmp, tmp_0, LabeledView$_set_content_$ref_ys1c8f());
        return tmp0.get();
      }
      onStartup_vrxh3i_k$() {
        this.container_1.onStartup_vrxh3i_k$();
        var target = findFirstInteractiveDescendant(this);
        if (!(target == null)) {
          this.label_1.set_labelFor_go6ca6_k$(target);
        }
      }
      get_gap_83dt6d_k$() {
        return this.container_1.get_gap_83dt6d_k$();
      }
      get_spacingForChildCornerRadii_uorqcm_k$() {
        return this.container_1.get_spacingForChildCornerRadii_uorqcm_k$();
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.container_1.get_underlyingNativeElement_vngz33_k$();
      }
      get_children_4cwbp4_k$() {
        return this.container_1.get_children_4cwbp4_k$();
      }
      addChild_51cm2s_k$(index, element) {
        this.container_1.addChild_51cm2s_k$(index, element);
      }
      addChild_2qpft2_k$(element) {
        this.container_1.addChild_2qpft2_k$(element);
      }
      removeChild_mjbjbk_k$(index) {
        this.container_1.removeChild_mjbjbk_k$(index);
      }
      removeChild_kofmvd_k$(element) {
        this.container_1.removeChild_kofmvd_k$(element);
      }
      clearChildren_eufjq4_k$() {
        this.container_1.clearChildren_eufjq4_k$();
      }
      get_context_h02k06_k$() {
        return this.container_1.get_context_h02k06_k$();
      }
      get_parent_hy4reb_k$() {
        return this.container_1.get_parent_hy4reb_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.container_1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.container_1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.container_1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.container_1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.container_1.get_visible_8zfvk9_k$();
      }
      set_paddingByEdge_53g79y_k$(_set____db54di) {
        this.container_1.set_paddingByEdge_53g79y_k$(_set____db54di);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.container_1.paddingByEdge_1;
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.container_1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.container_1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.container_1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.container_1.themeAndBack_1;
      }
      get_dragData_pas5on_k$() {
        return this.container_1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.container_1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.container_1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.container_1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.container_1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.container_1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.container_1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.container_1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.container_1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.container_1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.container_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.container_1.get_coroutineContext_115oqo_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.container_1.willAddChild_hz2iwc_k$(element);
      }
    }
    initMetadataForClass($, 'LabeledView', VOID, VOID, [LinearLayoutElement()]);
    LabeledViewClass = $;
  }
  return LabeledViewClass;
}
var LabelGapSemanticClass;
function LabelGapSemantic() {
  if (LabelGapSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        LabelGapSemantic_instance = null;
        super('labelgp');
        LabelGapSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, false, VOID, VOID, VOID, VOID, times(theme.gap_1, 0.1));
      }
      toString() {
        return 'LabelGapSemantic';
      }
      hashCode() {
        return 1441051047;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LabelGapSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LabelGapSemantic');
    LabelGapSemanticClass = $;
  }
  return LabelGapSemanticClass;
}
var LabelGapSemantic_instance;
function LabelGapSemantic_getInstance() {
  if (LabelGapSemantic_instance === VOID)
    new (LabelGapSemantic())();
  return LabelGapSemantic_instance;
}
function findFirstInteractiveDescendant(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, InteractiveElement()))
    return _this__u8e3s4;
  if (isInterface(_this__u8e3s4, ElementWithChildren())) {
    var _iterator__ex2g4s = _this__u8e3s4.get_children_4cwbp4_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var child = _iterator__ex2g4s.next_20eer_k$();
      var found = findFirstInteractiveDescendant(child);
      if (!(found == null))
        return found;
    }
  }
  return null;
}
//region block: exports
export {
  LabeledView as LabeledViewseav57tyecmf,
  findFirstInteractiveDescendant as findFirstInteractiveDescendant11suf5uyp4f72,
  LabelGapSemantic_getInstance as LabelGapSemantic_getInstance2wftjv243mafi,
  LabelSemantic_getInstance as LabelSemantic_getInstance4iffxvo6ijig,
};
//endregion

//# sourceMappingURL=labels.mjs.map
